import { isNil, reject } from 'ramda';

export const removeNull = reject(isNil);
